export const customStyles = {
    rows: {
        style: {
            minHeight: '72px',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            border: '0.05px solid #EAECF0'
        },
    },
    // header: {
	// 	style: {
	// 	},
	// },
    headRow: {
		style: {
			background: '#F9FAFB',
            color: '#667085',
            fontWeight: '600',
            fontSize: '1.2rem',
            border: '1px solid #EAECF0',
            minHeight: '4.4rem',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem'
		},
	},
    cells: {
        style: {
            //fontWeight: '400'
        }
    },
    headCells: {
        style: {
            //fontSize: '1rem'
        }
    }
}

export const customHeadStyles = {
    headCells: {
        style: {}
    }
}